/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimFormGeoDataResponse,
  ClaimFormResponse,
  ErrorResponse,
  PageClaimFormSearchResult,
} from '../models/index';
import {
    ClaimFormGeoDataResponseFromJSON,
    ClaimFormGeoDataResponseToJSON,
    ClaimFormResponseFromJSON,
    ClaimFormResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PageClaimFormSearchResultFromJSON,
    PageClaimFormSearchResultToJSON,
} from '../models/index';

export interface GetClaimFormByIdRequest {
    customerId: string;
    claimFormId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimFormGeoDataRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimFormSchemaRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface LinkClaimFormToReservationRequest {
    customerId: string;
    claimFormId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface MarkClaimFormAuthorizedRequest {
    customerId: string;
    claimFormId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface MarkClaimFormReceivedRequest {
    customerId: string;
    claimFormId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface RelinkClaimFormToReservationRequest {
    customerId: string;
    claimFormId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface SearchClaimFormsRequest {
    query: string;
    resultStart: number;
    resultEnd: number;
    customerId: string;
    startDate?: string;
    endDate?: string;
    linkStatus?: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UnlinkClaimFormFromReservationRequest {
    customerId: string;
    claimFormId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateClaimFormByIdRequest {
    customerId: string;
    claimFormId: string;
    requestBody: { [key: string]: any; };
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class ClaimFormsApi extends runtime.BaseAPI {

    /**
     * Get a claim form by its ID
     */
    async getClaimFormByIdRaw(requestParameters: GetClaimFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFormResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimFormById().'
            );
        }

        if (requestParameters['claimFormId'] == null) {
            throw new runtime.RequiredError(
                'claimFormId',
                'Required parameter "claimFormId" was null or undefined when calling getClaimFormById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/{claimFormId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimFormId"}}`, encodeURIComponent(String(requestParameters['claimFormId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFormResponseFromJSON(jsonValue));
    }

    /**
     * Get a claim form by its ID
     */
    async getClaimFormById(requestParameters: GetClaimFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFormResponse> {
        const response = await this.getClaimFormByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get geo data for claim form dropdowns
     */
    async getClaimFormGeoDataRaw(requestParameters: GetClaimFormGeoDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFormGeoDataResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimFormGeoData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/schema/geo-data`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFormGeoDataResponseFromJSON(jsonValue));
    }

    /**
     * Get geo data for claim form dropdowns
     */
    async getClaimFormGeoData(requestParameters: GetClaimFormGeoDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFormGeoDataResponse> {
        const response = await this.getClaimFormGeoDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the claim form schema for the current customer
     */
    async getClaimFormSchemaRaw(requestParameters: GetClaimFormSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimFormSchema().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/schema`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the claim form schema for the current customer
     */
    async getClaimFormSchema(requestParameters: GetClaimFormSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getClaimFormSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Links an existing claim form to a claim reservation.
     */
    async linkClaimFormToReservationRaw(requestParameters: LinkClaimFormToReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFormResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling linkClaimFormToReservation().'
            );
        }

        if (requestParameters['claimFormId'] == null) {
            throw new runtime.RequiredError(
                'claimFormId',
                'Required parameter "claimFormId" was null or undefined when calling linkClaimFormToReservation().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling linkClaimFormToReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/{claimFormId}/reservation/{claimReservationId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimFormId"}}`, encodeURIComponent(String(requestParameters['claimFormId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFormResponseFromJSON(jsonValue));
    }

    /**
     * Links an existing claim form to a claim reservation.
     */
    async linkClaimFormToReservation(requestParameters: LinkClaimFormToReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFormResponse> {
        const response = await this.linkClaimFormToReservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a claim form as authorized. Must be a different agent than the one who received it.
     */
    async markClaimFormAuthorizedRaw(requestParameters: MarkClaimFormAuthorizedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFormResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling markClaimFormAuthorized().'
            );
        }

        if (requestParameters['claimFormId'] == null) {
            throw new runtime.RequiredError(
                'claimFormId',
                'Required parameter "claimFormId" was null or undefined when calling markClaimFormAuthorized().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/{claimFormId}/authorized`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimFormId"}}`, encodeURIComponent(String(requestParameters['claimFormId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFormResponseFromJSON(jsonValue));
    }

    /**
     * Mark a claim form as authorized. Must be a different agent than the one who received it.
     */
    async markClaimFormAuthorized(requestParameters: MarkClaimFormAuthorizedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFormResponse> {
        const response = await this.markClaimFormAuthorizedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a claim form as received by the currently logged-in agent
     */
    async markClaimFormReceivedRaw(requestParameters: MarkClaimFormReceivedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFormResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling markClaimFormReceived().'
            );
        }

        if (requestParameters['claimFormId'] == null) {
            throw new runtime.RequiredError(
                'claimFormId',
                'Required parameter "claimFormId" was null or undefined when calling markClaimFormReceived().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/{claimFormId}/received`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimFormId"}}`, encodeURIComponent(String(requestParameters['claimFormId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFormResponseFromJSON(jsonValue));
    }

    /**
     * Mark a claim form as received by the currently logged-in agent
     */
    async markClaimFormReceived(requestParameters: MarkClaimFormReceivedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFormResponse> {
        const response = await this.markClaimFormReceivedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Atomically changes the reservation linked to a claim form.
     */
    async relinkClaimFormToReservationRaw(requestParameters: RelinkClaimFormToReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFormResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling relinkClaimFormToReservation().'
            );
        }

        if (requestParameters['claimFormId'] == null) {
            throw new runtime.RequiredError(
                'claimFormId',
                'Required parameter "claimFormId" was null or undefined when calling relinkClaimFormToReservation().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling relinkClaimFormToReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/{claimFormId}/reservation/{claimReservationId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimFormId"}}`, encodeURIComponent(String(requestParameters['claimFormId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFormResponseFromJSON(jsonValue));
    }

    /**
     * Atomically changes the reservation linked to a claim form.
     */
    async relinkClaimFormToReservation(requestParameters: RelinkClaimFormToReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFormResponse> {
        const response = await this.relinkClaimFormToReservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for claim forms by name, phone, or email
     */
    async searchClaimFormsRaw(requestParameters: SearchClaimFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageClaimFormSearchResult>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling searchClaimForms().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling searchClaimForms().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling searchClaimForms().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling searchClaimForms().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['linkStatus'] != null) {
            queryParameters['linkStatus'] = requestParameters['linkStatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/search`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageClaimFormSearchResultFromJSON(jsonValue));
    }

    /**
     * Search for claim forms by name, phone, or email
     */
    async searchClaimForms(requestParameters: SearchClaimFormsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageClaimFormSearchResult> {
        const response = await this.searchClaimFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unlinks a claim form from its reservation. The form is not deleted.
     */
    async unlinkClaimFormFromReservationRaw(requestParameters: UnlinkClaimFormFromReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling unlinkClaimFormFromReservation().'
            );
        }

        if (requestParameters['claimFormId'] == null) {
            throw new runtime.RequiredError(
                'claimFormId',
                'Required parameter "claimFormId" was null or undefined when calling unlinkClaimFormFromReservation().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling unlinkClaimFormFromReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/{claimFormId}/reservation/{claimReservationId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimFormId"}}`, encodeURIComponent(String(requestParameters['claimFormId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlinks a claim form from its reservation. The form is not deleted.
     */
    async unlinkClaimFormFromReservation(requestParameters: UnlinkClaimFormFromReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkClaimFormFromReservationRaw(requestParameters, initOverrides);
    }

    /**
     * Update a claim form by its ID
     */
    async updateClaimFormByIdRaw(requestParameters: UpdateClaimFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFormResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateClaimFormById().'
            );
        }

        if (requestParameters['claimFormId'] == null) {
            throw new runtime.RequiredError(
                'claimFormId',
                'Required parameter "claimFormId" was null or undefined when calling updateClaimFormById().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateClaimFormById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-forms/{claimFormId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimFormId"}}`, encodeURIComponent(String(requestParameters['claimFormId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFormResponseFromJSON(jsonValue));
    }

    /**
     * Update a claim form by its ID
     */
    async updateClaimFormById(requestParameters: UpdateClaimFormByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFormResponse> {
        const response = await this.updateClaimFormByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
